module.exports = __webpack_public_path__ + "static/media/19ESCAP5.f532fe5e.jpg";